import Button from "pages/configurator/components/button";
import Input from "pages/configurator/components/input";
import { FunctionComponent, useEffect } from "react";
import { ConfiguratorOptions, NodeCustomizer } from "@rromikas/configurio";
import CustomizerComponent from "../model-part-customizer/customizer";
import GroupSwitcher from "./group-switcher";
import { useModel } from "hooks/useModel";
import { useUndo } from "hooks/useUndo";
import { DELETE_GROUP_BUTTON_TEST_ID } from "constants/test";
import ChevronLeftIcon from "@heroicons/react/24/outline/ChevronLeftIcon";
import CustomizerHeader from "./customizer-header";

interface GroupCustomizerProps {
  initialValue?: NodeCustomizer;
  onSave: (val: NodeCustomizer) => void;
  model: ReturnType<typeof useModel>;
  customizers: ConfiguratorOptions["customizers"];
  onDelete: () => void;
  onClose: () => void;
}

const GroupCustomizer: FunctionComponent<GroupCustomizerProps> = ({
  onClose,
  onDelete,
  initialValue,
  onSave,
  model,
  customizers,
}) => {
  const [value, setValue] = useUndo<NodeCustomizer | undefined>(undefined);

  useEffect(() => {
    if (initialValue) {
      setValue(initialValue);
    }
  }, [initialValue]);

  return !value ? null : (
    <div className="px-6 pb-6 h-full overflow-auto">
      <CustomizerHeader
        onClose={onClose}
        onSave={() => onSave(value)}
        name={value.name}
        setName={(val) => setValue((prev) => (!prev ? prev : { ...prev, name: val }))}
      />
      <GroupSwitcher
        model={model}
        customizers={customizers}
        targetIndexes={value.targetIndexes}
        setTargetIndexes={(indexes) => setValue({ ...value, targetIndexes: indexes })}
      />
      <CustomizerComponent
        className="my-12"
        value={value.color}
        setValue={(val) => setValue({ ...value, color: val })}
        type="color"
      />
      <CustomizerComponent value={value.material} setValue={(val) => setValue({ ...value, material: val })} type="material" />
      <Button data-testid={DELETE_GROUP_BUTTON_TEST_ID} onClick={onDelete} variant="secondary-red" className="mt-12">
        Delete group
      </Button>
    </div>
  );
};

export default GroupCustomizer;
